// extracted by mini-css-extract-plugin
export default {"row":"buttons__row__NU0d_","btn":"buttons__btn__TaYnn","btnCopy":"buttons__btnCopy__DOetv","icon":"buttons__icon__xk_Sc","heroRow":"buttons__heroRow__SdXGj"};